import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import { WhatsAppFloat, StickyMobileCTA, ExitIntentPopup } from "./components/FloatingElements";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Simulateur from "./pages/Simulateur";
import Realizations from "./pages/Realizations";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Devis from "./pages/Devis";

import "@/App.css";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-[#0A0A0A] text-white grain relative">
        <Header />
        <main className="pb-20 md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/simulateur" element={<Simulateur />} />
            <Route path="/realisations" element={<Realizations />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <StickyMobileCTA />
        <ExitIntentPopup />
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121212",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.1)",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}
